import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "@emotion/styled-base";
var _excluded = ["name", "value", "options", "disabled", "size", "onChange", "variant"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React from 'react';
import PropTypes from 'prop-types';
import Flex from "../Flex";
import ButtonGroupOption from "./ButtonGroupOption";
import { v4 as uuidv4 } from 'uuid'; // Setting a transform here creates a stacking context, so the we can use z-index
// in ButtonGroupOption without worrying about z-index conflicts with other components

var ButtonGroupWrapper = /*#__PURE__*/_styled(Flex, {
  target: "esu5jem0",
  label: "ButtonGroupWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "41q668",
  styles: "transform:scale(1);"
} : {
  name: "41q668",
  styles: "transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ButtonGroup = function ButtonGroup(_ref) {
  var name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      onChange = _ref.onChange,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ButtonGroupWrapper, _extends({
    role: "radiogroup",
    "aria-label": name
  }, rest), options.map(function (option, index) {
    var _option$disabled;

    return /*#__PURE__*/React.createElement(ButtonGroupOption, {
      key: index,
      id: "buttonGroup_".concat(name, "_").concat(uuidv4()),
      name: name,
      label: option.label,
      value: option.value,
      checked: option.value === value,
      disabled: disabled || ((_option$disabled = option.disabled) !== null && _option$disabled !== void 0 ? _option$disabled : false),
      size: size,
      totalOptions: options.length,
      onChange: onChange,
      variant: variant
    });
  }));
};

ButtonGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    value: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]),
  variant: PropTypes.string
};
export default ButtonGroup;